import BoundaryError from 'common/components/BoundaryError'
import { fetchAdminFeatures } from 'gdl/adminFeatures/AdminFeaturesSlice'
import { fetchCommercialFeatures } from 'gdl/commercial/commercialFeature/CommercialFeaturesSlice'
import { fetchProducts } from 'gdl/commercial/product/ProductsSlice'
import NavBar from 'common/components/NavBar'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet, useLocation } from 'react-router'

const CommercialApp = () => {
    const dispatch = useDispatch()
    const { pathname } = useLocation()

    useEffect(() => {
        dispatch(fetchAdminFeatures())
        dispatch(fetchCommercialFeatures())
        dispatch(fetchProducts())
    }, [dispatch])

    const links = [
        { icon: 'request_quote', tooltip: 'Catalogue', url: '/commercial/feature' },
        { icon: 'app_shortcut', tooltip: 'Produits', url: '/commercial/product' },
    ]
    return (
        <>
            <NavBar links={links} />
            <BoundaryError url={pathname}>
                <div style={{ marginLeft: '65px' }}>
                    <Outlet />
                </div>
            </BoundaryError>
        </>
    )
}

export default CommercialApp